import { SET_ACTIVE_FACILITY } from "./types";

export const setActiveFacility = (facility) => (dispatch) => dispatch({ type: SET_ACTIVE_FACILITY, data: facility });

export const action_setActiveFacility = (facility) => ({
  type: SET_ACTIVE_FACILITY,
  data: facility,
});
